module.exports = __webpack_public_path__ + "img/maria-thalheim_seitenaltäre-kanzel_2020_ref.39ee80c1.jpg";